import * as React from 'react';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { styled } from '@mui/material';
import { MOBILE_NAV_ACTIVE_COLOR } from '../navigationColors';

const StyledBottomNavigationAction = styled((props) => <BottomNavigationAction {...props} />)({
  transitionProperty: 'color',
  minWidth: '75px',
  minHeight: 0,
  maxHeight: '44px',
  padding: '0 8px',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  '& .MuiBottomNavigationAction-icon': {
    minHeight: 24,
    height: 'auto',
    marginBottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '&:hover .MuiBottomNavigationAction-label': {
    color: MOBILE_NAV_ACTIVE_COLOR,
  },
  '.MuiBottomNavigationAction-label': {
    color: 'var(--trashie-ui-faded-black-70, #696969)',
    fontFamily: 'GT Maru',
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '100%',
    marginTop: '4px',
    '&.Mui-selected': {
      color: MOBILE_NAV_ACTIVE_COLOR,
      fontSize: '11px',
    },
  },
});

export default StyledBottomNavigationAction;
